import { GridColTypeDef } from "@mui/x-data-grid-pro";
import { get } from "lodash";
import moment from "moment";
import {
    parseFromISO,
    standardDateFormat,
    standardDateTimeFormat,
} from "utils/DateTimeUtils";

const createValueGetter = () => (_, row: any, column: any) => {
    let value = get(row, column.field);
    if (!value) return null;
    value = applyTimestampHeuristic(value);
    return value instanceof Date ? value : new Date(value);
};

const createValueFormatter =
    (useDateTime = false) =>
    (_, row: any, column: any) => {
        let value = get(row, column.field);
        if (!value) return "";
        value = applyTimestampHeuristic(value);

        const format = useDateTime
            ? standardDateTimeFormat
            : standardDateFormat;
        return format(parseFromISO(value, false));
    };

export const dateTimeColumnType: GridColTypeDef = {
    valueFormatter: createValueFormatter(true),
    type: "date",
    valueGetter: createValueGetter(),
};

export const dateColumnType: GridColTypeDef = {
    valueFormatter: createValueFormatter(false),
    type: "date",
    valueGetter: createValueGetter(),
};

export const applyTimestampHeuristic = (
    value: string | moment.Moment | Date,
): moment.Moment => {
    value = moment.utc(value);

    // check if timestamp is 00:00:00 and set to noon to avoid day change on local conversion
    if (value.hours() === 0 && value.minutes() === 0 && value.seconds() === 0) {
        value.set("hour", 12);
    }
    value = value.local();

    return value;
};
